import React from 'react'
import { Link, StaticQuery, graphql } from 'gatsby'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Button, MediaQuery } from '..'
import { Col, Row } from 'react-styled-flexboxgrid'
import variables from '../../styles/variables'
import AnimationWrapper from '../AnimationWrapper/AnimationWrapper'
import stepsAnimation from '../../lottie-animations/use-aito-steps1-and-2.json'

import * as styles from './styles'

const propTypes = {
  data: PropTypes.shape({
    stepsHeader: PropTypes.string,
    step1Header: PropTypes.string,
    step1Text: PropTypes.string,
    step2Header: PropTypes.string,
    step2Text: PropTypes.string,
    stepsButton: PropTypes.string,
  }).isRequired
}

const UsageSteps = ({ data }) => (
  <styles.UsageStepsContainer>
    <styles.UsageStepsSection>
      <Row>
        <Col sm={7} xs={12}>
          <styles.Header>
            {data.stepsHeader}
          </styles.Header>
          <styles.UsageStepsText>
            {data.stepsText}
          </styles.UsageStepsText>
          <styles.UsageStepsStep>
            <styles.UsageStepsHeader>
              <styles.UsageStepsNumber>
                1
              </styles.UsageStepsNumber>
              {data.step1Header}
            </styles.UsageStepsHeader>
            <styles.UsageStepsText>
              {data.step1Text}
            </styles.UsageStepsText>
          </styles.UsageStepsStep>
          <styles.UsageStepsStep>
            <styles.UsageStepsHeader>
              <styles.UsageStepsNumber>
                2
              </styles.UsageStepsNumber>
              {data.step2Header}
            </styles.UsageStepsHeader>
            <styles.UsageStepsText>
              {data.step2Text}
            </styles.UsageStepsText>
          </styles.UsageStepsStep>
          <styles.ButtonWrapper>
            <Link to="/product"><Button size="small">{data.stepsButton}</Button></Link>
          </styles.ButtonWrapper>
        </Col>
        <Col sm={5} xs={12}>
          <MediaQuery query={variables.media.sm}>
            <styles.CenterAnimation>
              <styles.UsageStepsAnimationContainer>
                <AnimationWrapper animation={stepsAnimation} />
              </styles.UsageStepsAnimationContainer>
            </styles.CenterAnimation>
          </MediaQuery>
        </Col>
      </Row>
    </styles.UsageStepsSection>
  </styles.UsageStepsContainer>
)

UsageSteps.propTypes = propTypes

export default () => (
  <StaticQuery
    query={graphql`
      query GetUsageSteps {
        allYaml(filter: {file: {eq: "index"}}) {
          edges {
            node {
              stepsHeader
              stepsText
              step1Header
              step1Text
              step2Header
              step2Text
              stepsButton
            }
          }
        }
      }
    `
    }
    render={(data) => {
      const { allYaml } = data
      const { edges } = allYaml
      const { node } = _.first(edges)
      return (
        <UsageSteps data={node} />
      )
    }}
  />
)
